var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"overlay fixed w-100",class:{ 'grow-layer': _vm.layerIndex },on:{"click":_vm.close}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }